import React, { useEffect, useRef, useState } from 'react';

function Brand() {
  return (
    <div className="brand">
      <img src="/banda-logo-320.png" alt="" className="brand-mark" />
      <span className="brand-name">Banda API</span>
    </div>
  );
}

function ProfileMenu({ me, onLogout }) {
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const onDocClick = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    const onEsc = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };

    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onEsc);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onEsc);
    };
  }, [open]);

  const initial = (me.username || '?').slice(0, 1).toUpperCase();

  return (
    <div className="profile" ref={boxRef}>
      <button
        type="button"
        className={`profile-btn${open ? ' is-open' : ''}`}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <span className="profile-avatar">{initial}</span>
        <span className="profile-name">{me.username}</span>
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" aria-hidden="true">
          <path
            d="M6 9.5 12 15.5 18 9.5"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {open ? (
        <div className="profile-pop">
          <div className="profile-pop-head">
            <span className="profile-avatar is-lg">{initial}</span>
            <div>
              <div className="profile-pop-name">{me.username}</div>
              <div className="profile-pop-role">
                {me.superAdmin ? 'Повний доступ' : `Прав: ${me.permissions?.length || 0}`}
              </div>
            </div>
          </div>

          <button type="button" className="profile-exit" onClick={onLogout}>
            <svg viewBox="0 0 24 24" width="15" height="15" fill="none" aria-hidden="true">
              <path
                d="M15 8.5V6.2A1.7 1.7 0 0 0 13.3 4.5H6.2A1.7 1.7 0 0 0 4.5 6.2v11.6A1.7 1.7 0 0 0 6.2 19.5h7.1a1.7 1.7 0 0 0 1.7-1.7V15.5M10 12h9.5m0 0-3-3m3 3-3 3"
                stroke="currentColor"
                strokeWidth="1.9"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Вийти
          </button>
        </div>
      ) : null}
    </div>
  );
}

export default function TopBar({ me, onLogout }) {
  return (
    <header className="topbar">
      <div className="topbar-inner">
        <Brand />
        {me && onLogout ? <ProfileMenu me={me} onLogout={onLogout} /> : null}
      </div>
    </header>
  );
}
